import { render, staticRenderFns } from "./teachingHardDialog.vue?vue&type=template&id=44b7aade"
import script from "./teachingHardDialog.vue?vue&type=script&lang=js"
export * from "./teachingHardDialog.vue?vue&type=script&lang=js"
import style0 from "./teachingHardDialog.vue?vue&type=style&index=0&id=44b7aade&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports